import { Box, Grid2 as Grid } from "@mui/material";
import { ProcessDataNumberWithCheckboxField } from "../form-fields/process-data/ProcessDataNumberWithCheckboxField";

export const TableCaveIn = () => {
	return (
		<Box padding={1}>
			<Grid container spacing={1} direction={"column"}>
				<Grid>
					<ProcessDataNumberWithCheckboxField
						numberField={"HeatsOnRoof"}
						checkboxField={"ForceHeatsOnRoof"}
						label={"Heats On Roof"}
					/>
				</Grid>
				<Grid>
					<ProcessDataNumberWithCheckboxField
						numberField={"HeatsOnRunnerSpout"}
						checkboxField={"ForceHeatsOnRunnerSpout"}
						label={"Heats On Runner Spout"}
					/>
				</Grid>
				<Grid>
					<ProcessDataNumberWithCheckboxField
						numberField={"HeatsOnTapHole"}
						checkboxField={"ForceHeatsOnTapHole"}
						label={"Heats On Tap Hole"}
					/>
				</Grid>
				<Grid>
					<ProcessDataNumberWithCheckboxField
						numberField={"HeatsOnLining"}
						checkboxField={"ForceHeatsOnLining"}
						label={"Heats On Lining"}
					/>
				</Grid>
				{/* <Grid>
					<ProcessDataCheckboxFieldDE
						field={"Electrode1"}
						label={"Electrode 1"}
					/>
				</Grid>
				<Grid>
					<ProcessDataCheckboxFieldDE
						field={"Electrode2"}
						label={"Electrode 2"}
					/>
				</Grid>
				<Grid>
					<ProcessDataCheckboxFieldDE
						field={"Electrode3"}
						label={"Electrode 3"}
					/>
				</Grid> */}
				{/* <Grid>
						<ProcessDataNumberTextField field={'Electrode1'} label={'Cave In A'}/>
					</Grid>
					<Grid>
						<ProcessDataNumberTextField field={'Electrode2'} label={'Cave In B'}/>
					</Grid>
					<Grid>
						<ProcessDataNumberTextField field={'Electrode3'} label={'Cave In C'}/>
					</Grid>
					<Grid>
						<ProcessDataNumberTextField field={'AverageCurrentPhaseA'} label={'Avg Curr A'}/>
					</Grid>
					<Grid>
						<ProcessDataNumberTextField field={'AverageCurrentPhaseB'} label={'Avg Curr B'}/>
					</Grid>
					<Grid>
						<ProcessDataNumberTextField field={'AverageCurrentPhaseC'} label={'Avg Curr C'}/>
					</Grid> */}
			</Grid>
		</Box>
	);
};
